import React, { useState } from 'react';

import PropTypes from 'prop-types';

import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { Icon } from '..';
import { ExpandButtonContainer, IconContainer } from './style';

const ExpandButton = ({ handleOnClick, fixShowLess }) => {
  const [expanded, setExpanded] = useState(false);

  const clickExpand = () => {
    if (handleOnClick) {
      if (handleOnClick() === false) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    } else {
      setExpanded(!expanded);
    }
  };

  return (
    <ExpandButtonContainer onClick={clickExpand}>
      <IconContainer>
        <Icon
          type={!expanded && !fixShowLess ? 'icon-add' : 'icon-minus'}
          size="16"
        />
      </IconContainer>
      <MainFont type="bold" configuration={{ fontSize: 14, lineHeight: 1.14 }}>
        {!expanded && !fixShowLess ? 'Show More' : 'Show Less'}
      </MainFont>
    </ExpandButtonContainer>
  );
};

ExpandButton.propTypes = {
  handleOnClick: PropTypes.func,
  fixShowLess: PropTypes.bool
};

export default ExpandButton;
